module.exports = __webpack_public_path__ + "img/2f_r_tonya.94429b3a.png";